exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.logo__img[data-v-2a286e69] {\n  width: 188px;\n  height: 60px;\n}\n@media only screen and (max-width: 599px) {\n.logo__img[data-v-2a286e69] {\n      width: 120px;\n      height: 40px;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2a286e69","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/common/Logotype.vue
// module id = tO6X
// module chunks = 1